function isValidWidth(width) {
    return width > 0 && width <= 12;
}
export default isValidWidth;
//# sourceMappingURL=is-valid-width.js.map